import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-payment-card',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './sign-payment-card.component.html',
  styleUrls: ['./sign-payment-card.component.scss'],
})
export class SignPaymentCardComponent {

}
